import { ChemicalUsageLog } from '../types';

export function createChemicalUsageLog(
	payload: Partial<ChemicalUsageLog>,
): Partial<ChemicalUsageLog> {
	if (!payload.chemical) throw new Error('A chemical reference is required');
	if (!payload.location) throw new Error('A location is required');
	if (!payload.appliedAt) throw new Error('An application date is required');
	if (payload.reiHours == null) throw new Error('REI hours is required');
	if (payload.reiHours < 0) throw new Error('REI hours cannot be negative');

	return {
		...payload,
		chemical: payload.chemical,
		location: payload.location,
		note: payload.note?.trim() || undefined,
		crops: payload.crops ?? [],
		reiHours: payload.reiHours,
		appliedAt: payload.appliedAt,
	};
}
